/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsEligibility204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsEligibility505Schema = z.any();

export const optionsEligibilityMutationResponseSchema = z.lazy(() => optionsEligibility204Schema);
